import { CurrentSubscription } from '../types';
import { SUBSCRIPTION_GRACE_PERIOD_DAYS, addDays } from './subscriptionConstants';

export const isWithinPaidPeriod = (subscription: CurrentSubscription) => {
	const now = new Date();

	// Check if the current_period_end hasn't elapsed yet
	if (!subscription.current_period_end) {
		return false;
	}

	const periodEnd = new Date(subscription.current_period_end);
	return periodEnd > now; // Still within paid period (true = still active, false = expired)
};

// Helper to check if subscription is in grace period
export const isInGracePeriod = (subscription: CurrentSubscription): boolean => {
	const now = new Date();

	if (!subscription.current_period_end) {
		return false;
	}

	// Cancelled subscriptions don't get grace period
	if (subscription.status === 'canceled') {
		return false;
	}

	const periodEnd = new Date(subscription.current_period_end);
	const periodEndWithGrace = addDays(periodEnd, SUBSCRIPTION_GRACE_PERIOD_DAYS);

	// In grace period if current period has ended but grace period hasn't
	return periodEnd < now && periodEndWithGrace > now;
};

// Helper to calculate days remaining in grace period
export const getDaysRemainingInGracePeriod = (subscription: CurrentSubscription): number => {
	if (!isInGracePeriod(subscription)) {
		return 0;
	}

	const now = new Date();
	const periodEnd = new Date(subscription.current_period_end);
	const periodEndWithGrace = addDays(periodEnd, SUBSCRIPTION_GRACE_PERIOD_DAYS);

	const msPerDay = 24 * 60 * 60 * 1000;
	const daysRemaining = Math.ceil((periodEndWithGrace.getTime() - now.getTime()) / msPerDay);

	return Math.max(0, daysRemaining);
};

// Helper to check if subscription allows software access (paid period + grace period)
export const hasSubscriptionAccess = (subscription: CurrentSubscription): boolean => {
	return isWithinPaidPeriod(subscription) || isInGracePeriod(subscription);
};
